import { Link } from 'react-router-dom';
import { paths } from 'core/routing/paths';
import { NavIcon } from 'shared/components/Icons';

export function AppHeader({
  t,
  locale,
  setLocale,
  dir,
  desktop,
  collapsed,
  onToggleSidebar,
  admin,
  onLogout,
  canViewNotifications,
}) {
  const toggleLabel = desktop
    ? (collapsed ? t('layout.expand') : t('layout.collapse'))
    : t('layout.menu');
  const collapseIcon = dir === 'rtl'
    ? (collapsed ? 'chevron' : 'collapse')
    : (collapsed ? 'collapse' : 'chevron');

  return (
    <header className="topbar">
      <div className="topbar-start">
        <button
          type="button"
          className="icon-btn touch-target"
          onClick={onToggleSidebar}
          aria-label={toggleLabel}
          aria-expanded={desktop ? !collapsed : undefined}
        >
          {desktop ? <NavIcon name={collapseIcon} /> : <NavIcon name="menu" />}
        </button>
        <p className="topbar-brand">{t('appName')}</p>
      </div>
      <div className="topbar-end">
        <div className="lang-switch" role="group" aria-label={t('layout.language')}>
          <button type="button" className={locale === 'ar' ? 'active' : ''} onClick={() => setLocale('ar')}>
            {t('language.ar')}
          </button>
          <button type="button" className={locale === 'en' ? 'active' : ''} onClick={() => setLocale('en')}>
            {t('language.en')}
          </button>
        </div>
        {canViewNotifications ? (
          <Link className="icon-btn touch-target" to={paths.notifications} aria-label={t('nav.notifications')}>
            <NavIcon name="notifications" />
          </Link>
        ) : null}
        <div className="profile-menu">
          <span className="admin-name">{admin?.name}</span>
          <button type="button" className="btn btn-ghost" onClick={onLogout}>
            {t('actions.logout')}
          </button>
        </div>
      </div>
    </header>
  );
}
